/* eslint-disable no-console */
export const log = (...args) => {
	console.log(...args);
};

export const error = (...args) => {
	console.error(...args);
};

export default {log, error};